const HOURLY_SEND_TIMES = Array.from({ length: 24 }, (_, hour) => {
  const hourValue = String(hour).padStart(2, "0");
  const displayHour = hour % 12 || 12;
  const period = hour < 12 ? "AM" : "PM";

  return { value: `${hourValue}:00`, label: `${displayHour}:00 ${period}` };
});

export const INITIAL_MESSAGE_SEND_TIMES = [
  { value: "+1m", label: "1 minute" },
  ...HOURLY_SEND_TIMES,
];

export const DEFAULT_INITIAL_MESSAGE_SEND_TIME = "10:00";

export const getInitialMessageSendTimes = () => INITIAL_MESSAGE_SEND_TIMES;

export const normaliseInitialMessageSendTime = (value) => {
  const normalisedValue = value === "+30s" ? "+1m" : value;

  return normalisedValue || DEFAULT_INITIAL_MESSAGE_SEND_TIME;
};
